import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { lighten } from 'polished'

const defaultIconColor: string = '#000'

export const ButtonContainer = styled.div`
    align-self: flex-start;
`
export const FilterIcon = styled(FontAwesomeIcon)`
    color: ${defaultIconColor};
    margin-left: 20px;
    &:hover {
      cursor: pointer;
      color: ${ lighten(0.5, defaultIconColor)} };
    }
`
